import Promise from 'bluebird';
import config from 'sharedConfig';
import { categoryByUrl } from 'shared/models/api';

const SET_CATEGORY = 'SET_CATEGORY';
const LOAD_CATEGORY = 'LOAD_CATEGORY';

const init = { title: '' };
export default function(state = init, action = {}) {
  switch (action.type) {
    case SET_CATEGORY:
      return { ...action.category, loading: false };
    case LOAD_CATEGORY:
      return { ...state, loading: true };
    default:
      return state;
  }
}

export function loadCategory({ searchQuery, categorySlug }) {
  return dispatch => {
    dispatch({ type: LOAD_CATEGORY });
    return Promise.resolve().then(() => {
      if (searchQuery) return dispatch(loadSearchQuery(searchQuery));

      const configCategory = config.nav[categorySlug];
      const categoryPromise = configCategory
        ? Promise.resolve(configCategory)
        : categoryByUrl(categorySlug).then(
            body => (body && body.category) || {}
          );

      return categoryPromise.then(categoryProps => {
        let category = {
          ...categoryProps,
          slug: categorySlug,
          searchQuery: null
        };

        const featuredBanners = config.featuredBanners;
        if (
          featuredBanners &&
          featuredBanners.categories &&
          featuredBanners.categories[category.tag]
        ) {
          category.featuredBanner = featuredBanners.categories[category.tag];
        } else {
          category.featuredBanner = null;
        }

        return dispatch({ type: SET_CATEGORY, category });
      });
    });
  };
}

function loadSearchQuery(searchQuery) {
  return {
    type: SET_CATEGORY,
    category: {
      title: 'Search Results for ' + searchQuery,
      searchQuery,
      slug: null
    }
  };
}



// WEBPACK FOOTER //
// ./shared/components/category/actions.js